import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { westChesterConfig } from "./data";

export default function WestChesterPage() {
  return <CityPageTemplate config={westChesterConfig} />;
}